module.exports = __webpack_public_path__ + "img/softwareBackground.cff1cd5e.jpg";